module.exports = __webpack_public_path__ + "static/aims-48ce3c44981096c0c2f03739af6a68ee.jpg";